import axios from "axios";
import Modal from "react-modal";
import { AES } from 'crypto-js';
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import React, { useState,useEffect, lazy, Suspense } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useQueryClient } from "react-query";
import { removeInvoiceFromCache } from "../services.js";
import invStatusConsts from "../../../constants/invStatusConsts";
import { logout, reset } from "../../../features/auth/authSlice";
import { INVOICE_STATUS } from "../../../constants/invoice.js";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
// import CommnetContainer from "../../Comments/CommnetContatiner";
const CommnetContainer = lazy(() => import("../../Comments/CommnetContatiner"));

const InvoiceActions = (props) => {
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [isCreatingPdf, setIsCreatingPdf] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState("");
  const path = window.location.pathname + window.location.search + window.location.hash;
  const user = useSelector((state) => state.auth.user);
  let token = null;
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 991);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const PENDING = 0;
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  let encodedId;

  const [isPrinting, setIsPrinting] = useState(false);

  const handlePrint = async () => {
    if (isPrinting) return;
    setIsPrinting(true);
    try {
      await axios.post(`/api/invoice/create`, props.invoiceView, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const response = await axios.get(`/api/invoice/download/created/pdf`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      });
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const printWindow = window.open(pdfUrl, "_blank");
      if (printWindow) {
        printWindow.addEventListener("load", () => {
          printWindow.focus();
          printWindow.print();
          URL.revokeObjectURL(pdfUrl);
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to prepare print.", { position: "bottom-right", autoClose: 3000 });
    } finally {
      setIsPrinting(false);
    }
  };

  const createPdf = async (e) => {
    e.preventDefault();
    setIsCreatingPdf(true); // Set loading state to true

    try {
      await axios.post(`/api/invoice/create`, props.invoiceView, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axios.get(`/api/invoice/download/created/pdf`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const filename = `${props.invoiceData.inv_number}.pdf`;
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      saveAs(pdfBlob, filename);
      toast.success(`Invoice "${props.invoiceData.inv_number}" downloaded successfully!`, {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      global.config.activityLog(
        window.location.href,
        "Invoice",
        `Invoice "${props.invoiceData.inv_number}" Downloaded Successfully!`
      );
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      // Display an error message to the user
      alert("Something went wrong while creating the PDF.");
    } finally {
      setIsCreatingPdf(false); // Set loading state to false, regardless of success or failure
    }
  };

  if (props.invoiceData) {
    const encryptedId = AES.encrypt(props.invoiceData._id, 'encryptionKey').toString();
    encodedId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');
  }

  const handleDeleteInvoice = async (id) => {
    setSelectedInvoiceId(id);
    setDeleteModalIsOpen(true);
  };

  const handleModalConfirm = async () => {
    try {
      setIsSubmitLoading(true);
      await axios.get(
        `/api/delete/invoice/${selectedInvoiceId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      removeInvoiceFromCache(queryClient, selectedInvoiceId);
      toast.success('Invoice removed successfully!', {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      global.config.activityLog(
        window.location.href,
        "Invoice",
        `Invoice "${props.invoiceData.inv_number}" removed Successfully!`
      );
      navigate("/user/invoices", { state: { fromInvoiceAction: true } });
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong");
    } finally {
      setIsSubmitLoading(false);
    }
    setDeleteModalIsOpen(false);
  };

  const handleModalCancel = () => {
    setDeleteModalIsOpen(false);
  };

  return (
    <div className="s1-contain s1-contain-with-comment s1-contain-with-comment-more">
      <div className="s1-contain-inner">
        <div className="bill-num-si">
          <a className="invoice-num-01">
            {props.invoiceData ? (
              props.invoiceData.inv_number
            ) : (
              <div
                style={{
                  width: "120px",
                  height: "32px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            )}
          </a>
          {props.invoiceData && (props.invoiceData.inv_status === invStatusConsts.Approved) && (<div className="approve-top">Approved</div>)}
          {props.invoiceData && (props.invoiceData.inv_status === invStatusConsts.Rejected) && (<div className="reject-top">Rejected</div>)}
        </div>
        <div className="btn-aary">
          {props.invoiceData && props.invoiceData.inv_status === PENDING && props.invoiceData.is_automatic_inv === false && (
            <Link className="editbtn-in-sle" to={`../invoice/edit/${encodedId}`}>
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.1304 6.07986L17.1903 1.11052C17.1194 1.03923 17.0256 1.00008 16.9253 1.00008C16.825 1.00008 16.7316 1.03924 16.6608 1.11053L13.734 4.05496L13.7305 4.0655L13.6721 4.11721L2.36765 15.4898C2.31526 15.5425 2.27983 15.6088 2.26536 15.6811L1.01394 21.9107C0.988996 22.0347 1.02743 22.1617 1.11626 22.2515C1.18712 22.3223 1.28094 22.3615 1.38125 22.3615C1.4062 22.3615 1.43066 22.3589 1.45361 22.3544L7.64718 21.0947C7.72004 21.0801 7.78541 21.0445 7.83731 20.9923L22.1304 6.6125C22.2013 6.54172 22.2397 6.44683 22.2397 6.34593C22.2397 6.24502 22.2008 6.15064 22.1304 6.07986ZM7.38716 20.3793L1.85881 21.504L2.976 15.9421L4.60782 14.3004L9.01897 18.7382L7.38716 20.3793ZM9.54794 18.2055L5.13679 13.7683L13.9441 4.90789L18.3548 9.3451L9.54744 18.2055L9.54794 18.2055ZM18.8847 8.81245L14.4741 4.37523L16.9253 1.90924L21.3365 6.34646L18.8847 8.81245Z" fill="white" stroke="white" strokeWidth="0.6"/></svg>{" "}Edit Invoice
            </Link>
          )}

          <a className="editbtn-in-slp" onClick={handlePrint} style={{ opacity: isPrinting ? 0.6 : 1, pointerEvents: isPrinting ? "none" : "auto" }}>
            {isPrinting ? (
              <span className="inv-btn-dots"><span /><span /><span /></span>
            ) : (
              <><svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.4255 6.37198H19.383V1.48836C19.383 1.35886 19.3292 1.23459 19.2334 1.14302C19.1377 1.05145 19.0077 1 18.8723 1H7.38298C7.10076 1 6.87234 1.21889 6.87234 1.48836V6.37198H4.57447C3.6266 6.37198 2.71748 6.73215 2.04681 7.37312C1.37614 8.0141 1 8.88399 1 9.79052V14.9183C1 15.8248 1.3766 16.6943 2.04681 17.3357C2.71702 17.9767 3.6266 18.3369 4.57447 18.3369H6.87234V21.5112C6.87234 21.6407 6.92614 21.765 7.02188 21.8565C7.11763 21.9481 7.24757 21.9996 7.38298 21.9996H18.8723C19.0077 21.9996 19.1377 21.9481 19.2334 21.8565C19.3292 21.765 19.383 21.6407 19.383 21.5112V18.3369H21.4255C22.3734 18.3369 23.2825 17.9767 23.9532 17.3357C24.6234 16.6947 25 15.8253 25 14.9183V9.79052C25 8.88399 24.6234 8.01454 23.9532 7.37312C23.283 6.73171 22.3734 6.37198 21.4255 6.37198ZM7.89362 1.97672H18.3617V6.37198H7.89362V1.97672ZM18.3617 17.8485V21.0228H7.89362V14.6741H18.3617V17.8485ZM23.9787 14.9183C23.9787 15.5663 23.7097 16.1872 23.231 16.645C22.7523 17.1029 22.1026 17.3601 21.4255 17.3601H19.383V14.1858C19.383 14.0563 19.3292 13.932 19.2334 13.8404C19.1377 13.7489 19.0077 13.6974 18.8723 13.6974H7.38298C7.10076 13.6974 6.87234 13.9163 6.87234 14.1858V17.3601H4.57447C3.89742 17.3601 3.24818 17.1029 2.769 16.645C2.29027 16.1872 2.02128 15.5663 2.02128 14.9183V9.79052C2.02128 9.143 2.29027 8.52165 2.769 8.06381C3.24772 7.60597 3.89742 7.34871 4.57447 7.34871H21.4255C22.1026 7.34871 22.7518 7.60597 23.231 8.06381C23.7097 8.52165 23.9787 9.143 23.9787 9.79052V14.9183Z" fill="#282828" stroke="#282828" strokeWidth="0.2"/><path d="M9.17031 17.3601H16.8299C17.1121 17.3601 17.3405 17.1417 17.3405 16.8718C17.3405 16.6018 17.1121 16.3834 16.8299 16.3834H9.17031C8.88809 16.3834 8.65967 16.6023 8.65967 16.8718C8.65967 17.1412 8.88809 17.3601 9.17031 17.3601Z" fill="#282828"/><path d="M9.17031 19.5577H16.8299C17.1121 19.5577 17.3405 19.3389 17.3405 19.0694C17.3405 18.7999 17.1121 18.581 16.8299 18.581H9.17031C8.88809 18.581 8.65967 18.7999 8.65967 19.0694C8.65967 19.3389 8.88809 19.5577 9.17031 19.5577Z" fill="#282828"/></svg>{" "}Print</>
            )}
          </a>

          <a className="editbtn-in-sldow" onClick={createPdf} style={{ opacity: isCreatingPdf ? 0.6 : 1, pointerEvents: isCreatingPdf ? "none" : "auto" }}>
            {isCreatingPdf ? (
              <span className="inv-btn-dots"><span /><span /><span /></span>
            ) : (
              <><svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.52625 15.8539C6.55157 15.8771 6.57923 15.8979 6.60884 15.9161L6.65014 15.9361L6.70235 15.9621L6.75689 15.9782L6.80482 15.9904C6.87651 16.0043 6.95092 16.0043 7.023 15.9904L7.07092 15.9782L7.12547 15.9621L7.17767 15.9361L7.21897 15.9161C7.24897 15.8979 7.27664 15.8771 7.30196 15.8539L12.6977 10.9C12.8773 10.7014 12.8625 10.41 12.6634 10.2275C12.4643 10.045 12.1464 10.0314 11.9298 10.1961L7.45702 14.3V1.5C7.45702 1.22393 7.21274 1 6.91157 1C6.6104 1 6.36612 1.22393 6.36612 1.5V14.3L1.89339 10.1961C1.67677 10.0314 1.35884 10.045 1.15975 10.2275C0.960661 10.41 0.945856 10.7014 1.12547 10.9L6.52547 15.8539H6.52625Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/></svg>{" "}Download</>
            )}
          </a>

          {props.invoiceData && props.invoiceData._id && props.invoiceData.inv_payment_status === 0 && (
            <a className="editbtn-in-sld" onClick={() => handleDeleteInvoice(props.invoiceData._id)}>
              <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9576 19.6445L17.4362 4.37761H19.577V3.85207H14.0107V2.45939C14.0107 1.69736 13.4314 1.09299 12.701 1.09299H7.96587C7.23545 1.09299 6.65615 1.69736 6.65615 2.45939V3.85207H1.08984V4.37761H3.23073L3.70928 19.6445C3.73447 20.354 4.28858 20.9058 4.96863 20.9058H15.6731C16.3783 20.9058 16.9324 20.354 16.9576 19.6445ZM7.15989 2.45939C7.15989 1.98641 7.51251 1.61853 7.96587 1.61853H12.701C13.1544 1.61853 13.507 1.98641 13.507 2.45939V3.85207H7.15989V2.45939ZM4.21302 19.6182L3.73447 4.37761H16.9324L16.4539 19.6182C16.4287 20.0386 16.1012 20.3802 15.6983 20.3802H4.96863C4.56564 20.3802 4.23821 20.0386 4.21302 19.6182Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/></svg>{" "}Delete
            </a>
          )}
        </div>
        {/* delete modal */}
        <Modal
          className={isMobile ? "mobile-action-modal" : "delete-modal"}
          overlayClassName={isMobile ? "mobile-sheet-overlay" : undefined}
          isOpen={deleteModalIsOpen}
          onRequestClose={!isSubmitLoading ? handleModalCancel : undefined}
          contentLabel="Confirm Deletion"
          closeTimeoutMS={480}
          style={{
            content: isMobile ? {
              position: "fixed",
              bottom: "0",
              top: "auto",
              left: "0",
              right: "0",
              width: "100%",
              maxWidth: "100%",
              borderRadius: "24px 24px 0 0",
              padding: "0 0 28px 0",
              border: "none",
              background: "#FFFFFF",
              transform: "none",
              inset: "auto 0px 0px 0px",
            } : {
              height: "41%",
              width: "30%",
              position: "fixed",
              top: "40%",
              left: "50%",
              parent: document.querySelector(".admin-outer.time.tracker"),
            },
          }}
        >
          {isMobile ? (
            <div className="mobile-bottom-sheet-content">
              <div className="mobile-bottom-sheet-header">
                <button type="button" className="mobile-sheet-close-circle" onClick={handleModalCancel} disabled={isSubmitLoading}>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <h3 className="mobile-sheet-title">Delete Invoice</h3>
              </div>
              <div className="mobile-sheet-body">
                <p className="mobile-sheet-msg">
                  Are you sure you want to <strong>delete</strong><br />this invoice?
                </p>
                <div className="mobile-sheet-btns">
                  <button
                    className="mobile-btn-sheet-reject"
                    onClick={handleModalConfirm}
                    disabled={isSubmitLoading}
                  >
                    {isSubmitLoading ? <span className="inv-btn-dots"><span /><span /><span /></span> : "Delete"}
                  </button>
                  <button className="mobile-btn-sheet-cancel" onClick={handleModalCancel} disabled={isSubmitLoading}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="modal del-pop-modal">
              <div className="outter-modal-main delmodalicon">
                <a onClick={handleModalCancel} disabled={isSubmitLoading}>
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41895 12L11.9189 1.5" stroke="#000" strokeWidth="1.5"/><path d="M1.41895 1.5L11.9189 12" stroke="#000" strokeWidth="1.5"/></svg>
                </a>
              </div>
              <h2>Confirm Deletion?</h2>
              <div>
                <div className="modal-content-del">
                  <p>Are you sure you want to delete this Invoice?</p>
                </div>
                <div className="button-container btn-2-in-modal btn-2-in-modal-delete">
                  <button className="buttons-rejected" onClick={handleModalConfirm} disabled={isSubmitLoading}>
                    {isSubmitLoading ? (
                      <div
                        style={{
                          width: "60px",
                          height: "18px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                          margin: "0 auto",
                        }}
                      />
                    ) : (
                      "Delete"
                    )}
                  </button>
                  <button className="Reject-singlebtn" onClick={handleModalCancel} disabled={isSubmitLoading}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </Modal>
        {/* modal end */}
      </div>
      <div className="comment-container-outer">
        {/* Your invoice layout */}
        {/* <CommnetContainer from={window.location.pathname + window.location.search + window.location.hash} /> */}
        
        <Suspense fallback={<div></div>}>
          <CommnetContainer
            from={window.location.pathname + window.location.search + window.location.hash}
            addUsers={[{
              _id:  props?.invoiceData?.inv_for?._id, //props?.invoiceData?.inv_created_by?._id ||
              name: (() => {
                const user =  props?.invoiceData?.inv_for; //props?.invoiceData?.inv_created_by ||
                if (!user) return '';
                return user.user_category !== 2
                  ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
                  : `${user.company_first_name || ''} ${user.company_last_name || ''}`.trim();
              })(),
               email:  props?.invoiceData?.inv_for?.email,
            }]}
            permissions={["Admin", "Super Admin"]}
          />
        </Suspense>
      </div>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default InvoiceActions;